import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as ChevronDownIcon } from "./../../assets/images/icons/Google SVGs/chevron_down.svg";

const ShowMoreLessButton = ({ content, init }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState("0px");
  const contentRef = useRef(null);

  useEffect(() => {
    setContentHeight(
      isExpanded ? `${contentRef.current.scrollHeight}px` : "147px"
    );
  }, [isExpanded]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="show-more-less-container">
      <div
        className={`content fs-12 fw-normal ${isExpanded ? "expanded" : ""}`}
        style={{
          maxHeight: contentHeight,
        }}
        ref={contentRef}
      >
        <p>
          {init && init}
        <strong
          className="fw-normal"
          dangerouslySetInnerHTML={{
            __html: content && content.replace(/\r\n/g, "<br />"),
          }}
        />
        </p>
      </div>
      <div
        className={`d-flex flex-row show-more-less-button w-100${
          isExpanded ? " expand" : ""
        }`}
      >
        <hr className="col my-auto color-bootstrap-gray-400 opacity-100" />
        <button
          className="btn h-fit rounded-2 border-1 border-bootstrap-gray-400 color-bootstrap-gray-700 fs-14 fw-normal px-2 py-0 mx-2"
          onClick={toggleExpand}
        >
          {isExpanded ? "کمتر" : "بیشتر"}
          <ChevronDownIcon
            className={`arrow ms-1${isExpanded ? " expand" : ""}`}
            width={24}
            height={24}
          />
        </button>
        <hr className="col my-auto color-bootstrap-gray-400 opacity-100" />
      </div>
    </div>
  );
};

export default ShowMoreLessButton;
